import React, { useContext, useEffect, useState } from "react";
import {
  LicenseTypes,
  Operation,
  TableHeaders,
} from "../../../utils/Enum.types";
import { Title } from "../../../stories/Title/Title";
import Input from "../../../stories/Input/Input";
import { Button } from "../../../stories/Button/Button";
import { StyledDatagrid } from "../../../styles/DatagridStyles";
import { useNavigate } from "react-router-dom";
import {
  HEADER_TEXT_ALIGN,
  MARKS_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../styles/Variables";
import { TableHeaderProps } from "../../../utils/types";
import useAssetTableJson from "../../../json/useAssetTableJson";
import Edit from "../../../images/EditProfile.svg";

import {
  GridAlignment,
  GridColDef,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { useLazyQuery } from "@apollo/client";
import { GetCustomers } from "./queries/queries";
import {
  GetCustomersResult,
  GetCustomersVar,
  MstCustomerEdge,
  MstCustomerOrderField,
} from "./queries/types";
import {
  CustomModal,
  getModifiedScrollHeight,
} from "../../../utils/UtilFunctions";
import { FETCH_MORE_DATA, ROWS_PER_PAGE } from "../../../utils/constants";

import { OrderDirection } from "../../../utils/commonQueryTypes";
import { EditModalStyles } from "../../../styles/CustomModalStyles";
import { AppContext } from "../../../context/context";
import { payloadTypes } from "../../../context/reducer";
import Navbar from "../../common/layout/Navbar";
import LoadingModal from "../../pages/LoadingModal";
import { useHotKey } from "../../../utils/hotKeys";
import { SpecialKeys } from "../../../utils/Enum.keys";
import EditCustomerModal from "./editCustomer/Index";

export type modalOpertaionFlag = {
  flag: boolean;
  operation: Operation;
};
const Index = () => {
  const { Customers_Table } = useAssetTableJson();
  

  const { dispatch } = useContext(AppContext);

  const navigate = useNavigate();
  const [searchData, setSearchData] = useState("");
  const [addModal, setAddModal] = useState<modalOpertaionFlag>({
    operation: Operation.CREATE,
    flag: false,
  });
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [customers, setCustomers] = useState<MstCustomerEdge[]>([]);
  const [editModal, setEditModal] = useState(false);
  const [endCursor, setEndCursor] = useState<string | null>(null);

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);

  const dynamicHeaders: TableHeaderProps[] = Customers_Table.List.map(
    (header) => ({
      headerName: header.headerName,
      className: header.cellClassName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
    })
  );
  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      field: "actions",
      cellClassName: "td-status ",
      headerAlign: HEADER_TEXT_ALIGN,
      align: MARKS_TEXT_ALIGN,
      headerName: TableHeaders.ACTION,
      renderCell: (params) => {
        return (
          <>
            <img
              src={Edit}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_CUST_ID,
                  payload: {
                    customerId: params.row.custId,
                  },
                });
                setAddModal({
                  flag: true,
                  operation: Operation.UPDATE,
                });
                setEditModal(true);
              }}
            />
            {/* <img
              src={Delete}
              alt=""
              onClick={() => {
                setDeleteModal(!deleteModal);
              }}
            /> */}
          </>
        );
      },
    },
  ];

  const [GetCustomersList, { data, loading, fetchMore }] = useLazyQuery<
    GetCustomersResult,
    GetCustomersVar
  >(GetCustomers);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetCustomers.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCustomer) => {
          const filteredStudent = customers.find(
            (customer) => customer.node.id === newCustomer.node.id
          );
          if (filteredStudent) {
            return {
              ...newCustomer,
              node: {
                ...newCustomer.node,
              },
            };
          }
          return newCustomer;
        });

        setCustomers(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            name: node.name,
            address: node.address,
            email: node.email,
            mobile: node.mobile,
            contactPerson: node.contactPerson,
            panNo: node.panNo,
            gst: node.gstNo,
            custId: node.id,
          }))
        );
      } else {
        setCustomers(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            name: node.name,
            address: node.address,
            email: node.email,
            mobile: node.mobile,
            contactPerson: node.contactPerson,
            panNo: node.panNo,
            gst: node.gstNo,
            custId: node.id,
          }))
        );
      }
      setEndCursor(data.GetCustomers.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [loading, data]);

  useEffect(
    () => {
      const scrollTable = document.getElementsByClassName(
        "MuiDataGrid-virtualScroller"
      )[0] as Element;
      const handleScroll = (e: Event) => {
        const target = e.target as HTMLDivElement;
        const scrollTop = target.scrollTop;
        const scrollHeight = target.scrollHeight;
        const clientHeight = target.clientHeight;
        if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
          if (hasNextPage && !loading) {
            fetchMore({
              variables: {
                first: FETCH_MORE_DATA,
                after: endCursor,
              },
              updateQuery: (prevResult, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prevResult;

                const newEdges = fetchMoreResult.GetCustomers.edges;
                const pageInfo = fetchMoreResult.GetCustomers.pageInfo;
                setEndCursor(pageInfo.endCursor);
                setHasNextPage(pageInfo.hasNextPage);

                const duplicateCheck = prevResult.GetCustomers
                  ? prevResult.GetCustomers.edges.filter(
                      ({ node: { id } }) =>
                        newEdges.findIndex(
                          ({ node: { id: newId } }) => newId === id
                        ) !== -1
                    )
                  : [];

                if (duplicateCheck.length > 0) return prevResult;

                return {
                  GetCustomers: {
                    edges: [...customers, ...newEdges],
                    pageInfo,
                    totalCount: data ? data.GetCustomers.totalCount! : 0,
                  },
                };
              },
            });
          }
        }
      };
      if (scrollTable && rows.length)
        scrollTable.addEventListener("scroll", handleScroll);

      return () => {
        // eslint-disable-next-line
        if (scrollTable)
          scrollTable.removeEventListener("scroll", handleScroll);
      };
    },
    // eslint-disable-next-line
    [rows]
  );

  useEffect(() => {
    GetCustomersList({
      variables: {
        after: null,
        first: ROWS_PER_PAGE,
        name: searchData,
        orderBy: {
          direction: OrderDirection.ASC,
          field: MstCustomerOrderField.NAME,
        },
        
      },
    });
  }, [GetCustomersList, searchData]);

  //hot key for addition ctrl+a
  useHotKey({
    handleFunc: () => {
      navigate("/0/addcustomerdetails");
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  return (
    <>
      <Navbar NavType={LicenseTypes.ADMIN} />
      <Title>Customers</Title>
      <div className="customer__list">
        <div className="row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search ..."
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSearchData(e.target.value)
              }
            />
          </div>
          <div className="col flex-end">
            <Button
              mode="addnew"
              autoFocus
              onClick={() => {
                navigate("/0/addcustomerdetails");
              }}
            />
          </div>
        </div>

        <div className="customer__list--tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            onCellClick={(params) => {
              if (params.field === "name")
                navigate(`/${params.row.custId}/customer/users`);
            }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>

      <CustomModal
        isOpen={editModal}
        onRequestClose={() => setEditModal(!editModal)}
        contentComponent={<EditCustomerModal setModalFlag={setEditModal} />}
        style={EditModalStyles}
      />
      <LoadingModal flag={loading} />
    </>
  );
};

export default Index;
